import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#a)" }, [
      _createElementVNode("path", {
        "fill-rule": "evenodd",
        d: "M22 5.5a2.25 2.25 0 0 0-2.25-2.25H4.25A2.25 2.25 0 0 0 2 5.5v1c0 .883.51 1.648 1.25 2.016V18.5a2.25 2.25 0 0 0 2.25 2.25h13a2.25 2.25 0 0 0 2.25-2.25V8.516A2.25 2.25 0 0 0 22 6.5zm-2.75 3.25H4.75v9.75c0 .414.336.75.75.75h13a.75.75 0 0 0 .75-.75zM3.5 6.5c0 .414.336.75.75.75h15.5a.75.75 0 0 0 .75-.75v-1a.75.75 0 0 0-.75-.75H4.25a.75.75 0 0 0-.75.75zM14 11a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1 0-1.5z",
        "clip-rule": "evenodd"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "a" }, [
        _createElementVNode("path", { d: "M0 0h24v24H0z" })
      ])
    ], -1)
  ]))]))
}
export default { render: render }